import { environment } from '../../../../../environments/environment';
export const site = {

    /** DEV */
    website: environment.website,
    displayWebsite: environment.displayWebsite,
    email: environment.email,
    apiHost: environment.apiHost,
    customerUrl: environment.customerUrl,
    displayCusUrl: environment.displayCusUrl,
    wpCouponSite: environment.wpCouponSite,
    picStories: environment.picStories,

}


export const spekwo = {
    spekwo: 'speKwo',
    phoneNumber: 'O. 866.646.0200',
    logoQuote: 'Instant quotes & reliable repairs for all items on your home inspection',
    website: site.website,
    displayWebsite: site.displayWebsite,
    customerUrl: site.customerUrl,
    displayCusUrl: site.displayCusUrl,
    email: site.email,
    picStories: site.picStories,

    logoUrl: 'assets/images/logos/spekwo.png',
    spekWalk: 'SpeK-Walk Summary Review',
    spekCall: 'SpeK-Call Summary Review',
    prouct1: 'HIQFULL',
    prouct2: 'INSPECTIONCALL',
    prouct3: 'GCCONSULTING',
    prouct4: 'CGPYWCK',
    prouct5: 'RJCZPSJ',
    'All Users': 'All Users',
    'Owner': 'Owner',
    'Solution Estimate': 'Solution Estimate',
    'speK ExeC': 'speK ExeC',
    'Senior Estimator': 'Senior Estimator',
    'Estimator': 'Estimator',
    'Spekwo Manager': 'speKwo Manager',
    'Pro': 'Pro',
    'HIQFULL': 'Full Spekwo',
    'GCCONSULTING': 'Walk and Talk',
    'INSPECTIONCALL': 'SpeK - Call',
    'RJCZPSJ': 'The Pre-List speK-Sheet',
    'CGPYWCK': 'Specific Item speKwo',
    'Seller': 'Seller',
    "Seller Agent": "Seller Agent",
    "Buyer Agent": "Buyer Agent",
    "Buyer": "Buyer",
    "Buyer Broker":"Buyer Broker",
    "Seller Broker" :"Seller Broker",
    "Buyer TM" : "Buyer TM",
    "Seller TM" : "Seller TM",

    defaultUrl: 'assets/images/avatars/profile.jpg',
    defaultImg: 'assets/images/avatars/default.jpg',
    defaultLogo: 'assets/images/avatars/default.jpg',
    productImg: 'assets/images/ecommerce/product-image-placeholder.png',
    defaultStory: 'assets/images/avatars/blank.png',
}
export const checkoutFields = {
    'createdVia': "checkout",
    'spekwoPage': '_tmcartepo_data',
    'deliveryTime': 'Delivery Time',
    'pdfContainer': '5cee82233ac0e3.86242120',


    'agentRole': 'billing_myfield1',
    'buyerProperty': 'billing_myfield2',
    'propertyRole': 'billing_myfield15',
    'clientName': 'billing_myfield23',
    'solEmail': 'billing_myfield24',
    'itemList' : 'item_list',
    'agentName': 'billing_agent_name',
    'agentEmail' : 'billing_agent_email',

    'homeInspectionReport': 'homeInspection',
    'preListPicture' : 'picUpload',
    'ddra': 'ddra',
    'uniqueReport' : 'uniqueReport',
    'supportReport' : 'supportReport',
    'supportingReport' : 'supportingReport',


    'specificKey1': '1-20 Items', //spekwo
    'specificKey2': '21-40 Items',//spekwo
    'specificKey3': '41-60 Items',//spekwo
    'walkInspectItems1': 'Areas to Inspect (Max 3, included in price)', //walktalk
    'walkInspectItems2': 'Additional items to Inspect (Additional $10 per category)',//walktalk
    'apptDate': 'myfield2',//spekcall & walktalk

    'customInvoiceClientName': 'custom_invoice_client_firstname',
    'customInvoiceClientEmail': 'custom_invoice_client_email',
    'trashOrderStatus': '_wp_trash_meta_status',

    invoiceCompleteStatus: 'completed',//from php

    archiveCompleteStatus: 'success', //from php
    archiveFailedStatus: 'failed', //from php
    //list
    archivedOrdersCompleteStatus: 'success', //from php
    archivedOrdersFailedStatus: 'failed', //from php

    checkOrdersCompleteStatus: 'success', //from php


    ocrDumpFetchStatus: 'completed', //from php,

    updateOrderStatusSuccess: 'success',//from php,
    updateOrderStatusFailed: 'failed',


    uploadCompanyLogoSuccess: 'completed',//from php,
    uploadCompanyLogoFailed: 'failed',

    // 'pdfContainer': '5d04d096d88c29.99106636',
}

export const stripeStatus = {
    'open': 'open',
    'paid': 'paid'
}
export const host = site.apiHost;

export const apiCalls = {

    apiId: 'AIzaSyCMAIvTjuT1nIw_dJv3cRnsbIPSyeMMRRo',
    channelId: 'UCTvtTeyyF3hQ8hJv97Gj_Ag',
    fbPost: 'https://www.facebook.com/SpeKwo-344051736111918/',
    bugTrack: 'https://bugtracker.zoho.com/portal/spekwo#myfeed',
    youtubeApi: 'https://www.googleapis.com/youtube/v3/search?key=',
    customOrder: site.website + 'custom-order-creation-for-spekwo',
    wpCouponSite: site.wpCouponSite,

    profileUrl: host + 'profiles/',
    logoUrl: host + 'logos/',

    ocrDocumentUrl: host + 'uploads/',
    ocrDocFetch: host + 'getOcrDocument.php',

    wcOrders: host + 'orders.php',
    wcOrdersTest: host + 'checkOrders.php',
    updateOrder: host + 'update_order.php?dev=true',
    attachment: host + 'attachment.php',
    getUploadDocumentUrls: host + 'getUploadFilesUrl.php',
    uploadStartUrl: host + 'profileDocuments/',

    ocrResponse: host + 'OCR_Response.php',
    getSolutionType: host + 'spreadsheet/getSolutionType.php',
    getDescCost: host + 'spreadsheet/getDescCost.php',
    payment: host + 'payment.php',
    manualUpload: host + 'manualUpload.php',
    manualFileProcessing: host + 'manualFileProcessing.php',

    sendMail: host + 'sendMail.php',
    passReportIdToClient: host + 'passReportIdToClient.php',
    // uploadToYoutube: 'http://172.104.179.88/SpekwoRest/uploadToYoutubeFinal.php',
    uploadToYoutube: host + 'uploadToYoutubeFinal.php',
    stripeInvToCustomer: host + 'invoiceCheck.php',
    getAllInvoicesWithCharges: host + 'getAllStripeInvoices.php',
    createArchiveOrder: host + 'archiveOrder.php',
    listArchiveOrders: host + 'getArchivedOrders.php',
    ocrDumpCollectionFetch: host + 'ocrDumpFetch.php',

    uploadCompanyFolder: 'companiesLogo',
    uploadTestimonialFolder: 'testimonial',
    uploadCompanyLogoandTestimonal: host + 'uploadCompanyLogoandTestimonal.php'

}
export const roles = [
    {
        'label': 'Pro',
        'value': 'Pro'
    },
    {
        'label': 'Solution Estimate',
        'value': 'Solution Estimate'
    },
    {
        'label': 'Estimator',
        'value': 'Estimator'
    },
    {
        'label': 'Senior Estimator',
        'value': 'Senior Estimator'
    },
    {
        'label': 'Spekwo Manager',
        'value': 'Spekwo Manager'
    },
    {
        'label': 'speK ExeC',
        'value': 'speK ExeC'
    },
    {
        'label': 'Owner',
        'value': 'Owner'
    },
    {
        'label': 'File Onboarder',
        'value': 'File Onboarder'
    },
    {
        'label': 'QCA',
        'value': 'QCA'
    },
    {
        'label': 'Blue Team',
        'value': 'Blue Team'
    },
   
];

export const customerRoles = [
    {
        viewValue: 'Current Owner/Seller',
        value: '7fbea184-0a71-11ec-8dcc-1722801e9c5c'
    },
    {
        viewValue: 'Owner/Buyer',
        value: '97f57cc8-0a71-11ec-8c9e-d7e9efc7b97c'
    },
    {
        viewValue: 'Buyer Broker',
        value: 'af946e84-0a71-11ec-a1ac-c77b1631d3f6'
    },
    {
        viewValue: 'Seller Broker',
        value: 'c5573602-0a71-11ec-b562-cba27195b2b8'
    },
];

export const trashOrderStatus = {
    'wc-processing': 'processing',
    'wc-pending': 'pending',
    'wc-completed': 'completed',
    'wc-on-hold': 'on-hold',
    'wc-cancelled': 'cancelled',
    'wc-failed': 'failed'
}
export const agentRoles = [
    {viewValue : 'Buyer Broker', value:'Buyer Broker'},
    {viewValue : 'Seller Broker', value:'Seller Broker'},
    {viewValue : 'Buyer TM', value:'Buyer TM'},
    {viewValue : 'Seller TM', value:'Seller TM'},
];
export const clientRole = [
    {viewValue : 'Buyer', value:'Buyer'},
    {viewValue : 'Seller', value:'Seller'},
];


// WEBPACK FOOTER //
// I:/1.speKwo/New Spekwo Revamp/admindash/src/app/main/content/apps/utils/spekwo.ts